import {
  LOAD_VEHICLE_RMCCONCRETETRIP,
  LOAD_VEHICLE_TYPE_RMCCONCRETETRIP,
  LOAD_PLANT_RMCCONCRETETRIP,
  EXPORT_RMCCONCRETETRIP_REPORT,
  EXPORT_RMCCONCRETETRIP_REPORT_PREVIEW,
  LOAD_DIVISION,
} from './actions'

const initialState = {
  Url: '',
  plantLists: [],
  vehicleLists: [],
  vehicleTypeLists: [],
  divisionLists: [],
  loading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_VEHICLE_RMCCONCRETETRIP.REQUEST:
      const { loading_vehicle } = action.payload
      return {
        ...state,
        loading: true,
      }

    case LOAD_VEHICLE_RMCCONCRETETRIP.SUCCESS:
      return {
        ...state,
        vehicleLists: action.payload.data.data,
        loading: false,
      }

    case LOAD_VEHICLE_TYPE_RMCCONCRETETRIP.SUCCESS:
      return {
        ...state,
        vehicleTypeLists: action.payload.data.data,
      }

    case LOAD_PLANT_RMCCONCRETETRIP.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case LOAD_PLANT_RMCCONCRETETRIP.SUCCESS:
      return {
        ...state,
        plantLists: action.payload.data.data,
        loading: false,
      }

    case EXPORT_RMCCONCRETETRIP_REPORT.REQUEST:
    case EXPORT_RMCCONCRETETRIP_REPORT_PREVIEW.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case EXPORT_RMCCONCRETETRIP_REPORT.SUCCESS:
    case EXPORT_RMCCONCRETETRIP_REPORT_PREVIEW.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case LOAD_DIVISION.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case LOAD_DIVISION.SUCCESS:
      return {
        ...state,
        divisionLists: action.payload.data,
        loading: false,
      }

    default:
      return state
  }
}
